/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { connect } from 'react-redux';
import Brand from "./Brand"
import Visuals from "./Visuals"
import Quotes from "./Quotes"
import Jobs from "./Jobs"
import Allaccounts from "./Allaccounts"

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';


function Index(props) {
  const [activeTab, setActiveTabe] = useState('1');

  useEffect(() => {
  },[]);
  

  const toggle=(tab)=> {
    if (activeTab !== tab) {
      setActiveTabe(tab)
    }
  }

  return (
    <Row className="mt-3 orders-tabs">
      <Col  md="12">
        <div>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => { toggle('1'); }}
              >
                Account
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => { toggle('2'); }}
              >
                Brand
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' })}
                onClick={() => { toggle('3'); }}
              >
                Quotes
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '4' })}
                onClick={() => { toggle('4'); }}
              >
                Jobs
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '5' })}
                onClick={() => { toggle('5'); }}
              >
                Visuals
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="">
              <Row>
                <Col sm="12">
                    <Allaccounts history={props.history}/>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2" className="">
              <Row>
                <Col sm="12">
                  <Card body>
                    <Brand/>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="3" className="">
              <Row>
                <Col sm="12">
                  <Card body>
                    <Quotes history={props.history}/>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="4" className="">
              <Row>
                <Col sm="12">
                  <Card body>
                    <Jobs history={props.history}/>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="5" className="">
              <Row>
                <Col sm="12">
                  <Card body>
                    <Visuals/>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </Col>
    </Row>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
